<template>
  <div class="shopCallStaff">
    <div class="callStaffHeader notranslate">
      {{ locale.call_staff_menu }}
      <span>{{ locale.message_select_item }}</span>
      <button type="button" class="btnClose" @click.stop="close">{{ locale.close }}</button>
    </div>
    <div class="callStaffBody">
      <div class="itemList">
        <button type="button"
          v-for="item in itemList"
          :key="item.shopItemId"
          :style="isActive(item.shopItemId) && getDefaultBtnStyleReverse"
          :disabled="isActive(item.shopItemId)"
          class="item"
          @click.stop="addOrder(item)">
          {{ item.shopItemName[lang] }}
        </button>
      </div>
      <div class="callRequest">
        <div ref="orderList" class="orderList storeCartList">
          <div v-if="!orderList.length" class="messageCall notranslate" v-html="callStaffOnly()"></div>
          <div v-for="item in orderList"
            :key="item.shopItemId"
            class="item">
            <div class="name">
              {{ item.shopItemName[lang] }}
              <button type="button" class="btn btnWhite btnDel" @click.stop="delOrder(item.shopItemId)">{{ locale.delete }}</button>
            </div>
            <div class="quantity notranslate">
              <button type="button" class="btnMinus" @click.stop="handleMinus(item.shopItemId)"></button>
              <span class="qty">{{ item.quantity }}{{ locale.unit_item }}</span>
              <button type="button" class="btnPlus" @click.stop="handlePlus(item.shopItemId)"></button>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="btn btnRequest notranslate"
          :style="getDefaultBtnStyle"
          @click.stop="requestCall">
          {{ !orderList.length ? locale.call : locale.do_request }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'callStaff',
  props: [
    'locale',
    'lang',
    'isAuth',
    'responsive',
    'shopPageId',
    'shopResponsive'
  ],
  components: {
  },
  computed: {
    getShopResultData () {
      return this.$store.getters['shop/getShopResultData']
    },
    isStore () {
      return this.$route.name === 'store'
    },
    getDefaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    getDefaultBtnStyleReverse () {
      return this.$store.getters['common/getDefaultBtnStyleReverse']
    },
    getItemProperties () {
      return this.$store.getters['shop/getItemProperties']
    },
    callStaff () {
      return this.$store.getters['shop/getCallStaff']
    },
    itemList () {
      const callStaffItems = this.callStaff && this.callStaff.items
      const itemProperty = this.getItemProperties
      // return callStaffItems.map(shopItemId => itemProperty && itemProperty[shopItemId]).filter(item => item && item.shopItemId)

      // 인덱스 저장되지 않았을 때 추가만 된 아이템
      const addedItems = Object.values(itemProperty).filter(item => {
        const category = item.categoryIds || []
        const hasCallStaff = category.includes('call-staff')
        const notIncludedId = !callStaffItems.includes(item.shopItemId)
        return hasCallStaff && notIncludedId
      }).map(item => item.shopItemId)
      const items = callStaffItems.concat(addedItems)
      return items.map(shopItemId => itemProperty && itemProperty[shopItemId]).filter(item => item && item.shopItemId)
    }
  },
  data () {
    return {
      orderList: []
    }
  },
  methods: {
    isActive (shopItemId) {
      return this.orderList.find(x => x.shopItemId === shopItemId)
    },
    callStaffOnly () {
      const message = this.locale.message_call_staff_only
      const call = this.locale.call
      const replaceMessage = message.replace('{var}', `<strong>${call}</strong> `)
      return replaceMessage
    },
    addOrder (item) {
      const orderItem = {
        shopItemId: item.shopItemId,
        shopItemName: item.shopItemName,
        quantity: item.quantity.min,
        min: item.quantity.min,
        max: item.quantity.max,
        categoryId: 'call-staff',
        priceInfo: {
          ...item.priceInfo
        },
        ...item.pId && {
          pId: item.pId
        }
      }
      this.orderList.push(orderItem)
      this.$nextTick(() => {
        this.scrollOrderList()
      })
    },
    delOrder (shopItemId) {
      this.orderList = this.orderList.filter(x => x.shopItemId !== shopItemId)
    },
    // 요청항목이 쌓이면 최하단으로 스크롤
    scrollOrderList () {
      const orderList = this.$refs.orderList
      if (orderList) {
        orderList.scrollTop = orderList.scrollHeight
      }
    },
    handleMinus (shopItemId) {
      this.orderList = this.orderList.map(x => {
        const isItem = x.shopItemId === shopItemId
        return {
          ...x,
          ...isItem && {
            quantity: x.min >= x.quantity - 1 ? x.min : x.quantity - 1
          }
        }
      })
    },
    handlePlus (shopItemId) {
      this.orderList = this.orderList.map(x => {
        const isItem = x.shopItemId === shopItemId
        return {
          ...x,
          ...isItem && {
            quantity: x.max <= x.quantity + 1 ? x.max : x.quantity + 1
          }
        }
      })
    },
    close () {
      this.$store.commit('shop/setCallStaff', false)
    },
    // shop(product v2) items check billing
    async checkOrderStatus () {
      /**
       * 주문하려는 상품의 shopPageId별 빌링(포스결제)이 발생했는지 체크
       * 발생이 되었다면 해당 ota는 만료처리 되기 때문에
       * 새로운 ota로 주문까지 계속 진행해야 한다
       * 이 케이스는 pos연동시에만 관계가 있으므로 연동되지 않는 환경에서는 불필요함(무조건200ok)
       */
      const shopPageIds = [this.shopPageId] // store에서만 사용하는 장바구니 이므로 pageId는 한개임
      if (!shopPageIds) return true
      try {
        const res = await Promise.all(
          shopPageIds.map(data => this.$store.dispatch('order/checkOrderStatus', data))
        )
        const result = res.map(r => r.result || r.status)
        const reqOta = result.find(x => x.newOTAKey)
        const errorItem = result.find(e => e && e.code)
        const errors = errorItem && this.getShopResultData(errorItem.code || 500)
        if (errors) {
          alert(`${errors}\n${errorItem.reason}`)
          return false
        } else {
          return reqOta || true
        }
      } catch (error) {
        console.log(error)
        const errors = error && this.getShopResultData(error.code || 500)
        alert(`${errors}\n${errors.reason}`)
        return false
      }
    },
    // shop(product v2) items submit
    async submitShopItems () {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      const firstItem = this.orderList[0] ? this.orderList[0].shopItemName[this.lang] : null
      const itemLength = this.orderList && this.orderList.length <= 1 ? '' : `(+${this.orderList.length - 1})`
      const completeMessage = firstItem ? `"${firstItem}${itemLength}" ${this.locale.complete_request_item}` : this.locale.complete_call_staff
      /**
       * payload 아이템 데이터 중
       * 다국어 객체 찾아 번역에 사용하는 값만 남기고 삭제
       */
      const excludeLangs = this.$store.getters['util/excludeLangs']
      const deepFilter = (data) => {
        const filterLangs = /name|shopItemName/
        if (Array.isArray(data)) {
          return data.map(deepFilter)
        } else if (data && typeof data === 'object') {
          return Object.entries(data).reduce((acc, [key, value]) => {
            acc[key] = filterLangs.test(key) && typeof value === 'object'
              ? excludeLangs(value)
              : deepFilter(value)
            return acc
          }, {})
        }
        return data
      }
      
      const shopItems = firstItem
      ? this.orderList.map(x => {
        return {
          ...deepFilter(x),
          pageId: this.shopPageId
        }
      })
      : [
        {
          shopItemId: 'call-staff',
          shopItemName: {
            ko: '직원 호출',
            en: 'Call Staff',
            'zh-CN': '呼叫员工',
            ja: '呼び出し'
          },
          quantity: 1,
          categoryId: 'call-staff',
          priceInfo: {
            gross: '0'
          },
          pageId: this.shopPageId
        }
      ]
      const submitData = {
        catCode: shopCatCode,
        payload: shopItems
      }
      try {
        const res = await this.$store.dispatch('order/setSubmit', { data: submitData })
        if (res && res.status === 200) {
          this.$emit('complete', completeMessage)
          this.orderList = []
        } else {
          const errorCode = res && res.result && res.result.code || 500
          const errorMessage = this.getShopResultData(errorCode)
          alert(errorMessage)
        }
        return res
      } catch (e) {
        console.error('[submitShopItems error]', e)
        return false
      }
    },
    async requestCall () {
      this.$store.commit('loading', true)
      const checkOrderStatus = await this.checkOrderStatus()
      if (checkOrderStatus) {
        if (checkOrderStatus.newOTAKey) {
          await this.$store.dispatch('authentication/getOtaKey', true)
        }
        await this.submitShopItems()
        this.$store.commit('loading', false)
      } else {
        if (res.message && res.message.length) {
          if (res.message.includes('Unauthorized')) {
            // 유효하지 않은 인증키입니다.
            this.$emit('setToastMessage', this.locale.invalid_key)
          } else if (res.message.includes('amount')) {
            // 결제할 수 없는 금액입니다.
            this.$emit('setToastMessage', this.locale.alert_amount_cannot_paid)
          } else if (res.message.includes('currency')) {
            // 지원하지 않는 통화입니다.
            this.$emit('setToastMessage', this.locale.alert_currency_not_support)
          } else {
            // 시스템에러가 발생했습니다.
            this.$emit('setToastMessage', this.locale.alert_system_error)
          }
        } else {
          // 시스템에러가 발생했습니다.
          this.$emit('setToastMessage', this.locale.alert_system_error)
        }
        this.$store.commit('loading', false)
      }
      this.close()
    }
  }
}
</script>